// extracted by mini-css-extract-plugin
export var separator = "common-recipe-molecules-module--separator--zUUHg";
export var simpleView = "common-recipe-molecules-module--simple-view--E4+8f";
export var title = "common-recipe-molecules-module--title--h4bEa";